export default __webpack_public_path__ + "media/images/logos/plus-divide-white-aa1bbd934b5a4628cee0a718661442fe.svg";